module.exports = __webpack_public_path__ + "static/media/ic-settings-active.56278332.svg";